module.exports = __webpack_public_path__ + "img/zw1.49ad9c33.png";